import * as dotProp from 'dot-prop-immutable';
import * as types from 'actions/types';

const INITIAL_STATE = {
  path: [],
  selectedRecommendation: null,
  selectedPreviousRecommendation: null,
};

const commerceWizard = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_COMMERCE_WIZARD_PATH:
      return dotProp.set(state, 'path', action.path);
    case types.SET_COMMERCE_WIZARD_SELECTED_RECOMMENDATION:
      return dotProp.set(state, 'selectedRecommendation', action.selectedRecommendation);
    case types.SET_COMMERCE_WIZARD_PREVIOUS_RECOMMENDATION:
      return dotProp.set(state, 'selectedPreviousRecommendation', action.selectedPreviousRecommendation);
    default:
      return state;
  }
};

export default commerceWizard;
